import {gql} from '@apollo/client';

export const USED_VEHICLE = gql`
  query getUsedVehicleByVinAndZip(
    $zipcode: String!
    $vin: String!
    $mapsUrlTemplate: String
  ) {
    usedVehicle: getUsedVehicleByVinAndZip(
      zipcode: $zipcode
      vin: $vin
      mapsUrlTemplate: $mapsUrlTemplate
    ) {
      adjustedListPrice
      dealerDeeplink
      dealerEnrollmentStatusInd
      dealerProvider
      engineDescription
      engineDescription
      engineFuelType
      exteriorColorBaseColor
      factoryExteriorCode
      mediaImageUrl
      model
      modelCode
      modelCodeKey
      modelYear
      mpgCity
      mpgHighway
      odometer
      onlineSalesURL
      photoCount
      standardFeatures
      stockNum
      subTrimLevel
      transmissionDescription
      trimLevel
      usedType
      vin
      carfaxLink {
        iconUrl
        url
      }
      dealer {
        address1
        address2
        city
        dealerid
        distance
        name
        phone
        postalcode
        state
        staticMapsUrl
        url
      }
    }
  }
`;
